import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';

export const NAVBAR_LOGO = "https://coincap.io/static/logos/black.svg"
export const FOOTER_GOOGLE_LOGO = "https://coincap.io/static/images/stores/google_play.svg"
export const FOOTER_APPLE_LOGO = "https://coincap.io/static/images/stores/apple_store.svg"
export const TWITTER_ICON = TwitterIcon
export const FACEBOOK_ICON = FacebookIcon